import { CheckCircleFilled, LoadingOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import classNames from 'classnames'
import { FC, MouseEvent } from 'react'
import cn from './index.module.css'

interface IProcessedCheckIcon {
  processed?: boolean | 0 | 1 | null
  disabled?: boolean
  loading?: boolean
  onToggle?: () => void
  className?: string
}

export const isContractProcessed = (
  value?: boolean | 0 | 1 | null,
): boolean => value === true || value === 1

const ProcessedCheckIcon: FC<IProcessedCheckIcon> = ({
  processed,
  disabled = false,
  loading = false,
  onToggle,
  className,
}) => {
  const isProcessed = isContractProcessed(processed)

  const handleClick = (event: MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()
    if (disabled || loading) return
    onToggle?.()
  }

  if (loading) {
    return (
      <span
        className={classNames(cn.checkButton, cn.loadingWrapper, className)}
        aria-label="Изменение статуса обработки"
      >
        <LoadingOutlined
          spin
          className={cn.loadingIcon}
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        />
      </span>
    )
  }

  return (
    <Tooltip
      title={
        isProcessed ? 'Статус договора: обработан' : 'обработать договор'
      }
    >
      <button
        type="button"
        className={classNames(
          cn.checkButton,
          isProcessed ? cn.processed : cn.unprocessed,
          className,
        )}
        onClick={handleClick}
        disabled={disabled}
        aria-label={
          isProcessed ? 'Статус договора: обработан' : 'обработать договор'
        }
      >
        <CheckCircleFilled
          className={cn.checkIcon}
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        />
      </button>
    </Tooltip>
  )
}

export default ProcessedCheckIcon
